export default [
  {
    path: '/setup-landing-pages',
    name: 'setup-landing-page',
    meta: { requiresAuth: true },
    component: () => import('@/pages/setup-landing-page/index.vue')
  }
]
